import React, { memo } from 'react';
import { useTranslation } from '@dm/i18n';
import { theme } from '../../..';
import { IconProps, DEFAULT_IMAGE_SIZE } from '../icon';
import IconSvg from '../IconSvg';

// Note: when changing this file, also update checkbox's backgroundImage!
const Check = (props: IconProps) => {
  const [t] = useTranslation();
  const {
    id,
    color = theme.palette.color2.hex,
    description,
    dmId = 'dm-check',
    pointerEvents = 'none',
    secondColor,
    size = DEFAULT_IMAGE_SIZE,
    title = t('ds.icon.check.title'),
    ...otherProps
  } = props; // we also need to define unused props because of otherProps
  return (
    <IconSvg
      id={id}
      description={description}
      dmId={dmId}
      pointerEvents={pointerEvents}
      size={size}
      title={title}
      {...otherProps}>
      <path
        fill={color}
        d="M18.19,4.89a2.22,2.22,0,0,1,3.36,2.9L21.36,8,10.48,19.11a2.24,2.24,0,0,1-3,.19l-.21-.19L2.64,14.35a2.22,2.22,0,0,1,3-3.3l.21.19,3.08,3.14Z"
      />
    </IconSvg>
  );
};

export default memo(Check);
